export default __webpack_public_path__ + "static/media/1_0078.a6cf3068.webp";